import { formatDate } from './formatDate';
import { getDifferenceInWeeks } from './getDifferenceInWeeks';
import { getMaxDate } from './getMaxDate';
import { getLastMonday } from './getLastMonday';
import { getWeeksAdded } from './getWeeksAdded';

export function getMondayOptions() {
  const DEFAULT_MONTH = 11;
  const DEFAULT_WEEKS = 3;
  const DEFAULT_YEARS = 2;
  const maxDate = getMaxDate(new Date(), {
    month: DEFAULT_MONTH,
    years: DEFAULT_YEARS,
  });
  const minDate = getWeeksAdded(getLastMonday(new Date()), DEFAULT_WEEKS);
  const weeks = Array(getDifferenceInWeeks(maxDate, minDate) + 1);
  const setMondayOptions = (date) => (options, _, index) => {
    const newDate = getWeeksAdded(date, index);
    const text = formatDate(newDate, 'month-number');
    const value = formatDate(newDate, 'iso-string');

    return [...options, { text, value }];
  };

  return Array.from(weeks).reduce(setMondayOptions(minDate), []);
}
